import { render, staticRenderFns } from "./registration.vue?vue&type=template&id=5a758d96&scoped=true&"
import script from "./registration.vue?vue&type=script&lang=ts&"
export * from "./registration.vue?vue&type=script&lang=ts&"
import style0 from "./registration.vue?vue&type=style&index=0&id=5a758d96&lang=scss&scoped=true&"
import style1 from "./registration.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a758d96",
  null
  
)

export default component.exports